import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import {
  FX_EMAIL,
  FX_PHONE,
  STATUS_CANCELLED,
  STATUS_FAIL,
} from 'constants';
import { datePicker } from 'helpers';
import useFxAddTransaction from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import useTheme from 'hooks/useTheme';
import React, { useEffect, useState } from 'react';
import { stringUtils } from 'utils';

const withCheckMakePaymentExpired = (Component) => {
  const CheckMakePaymentExpiredComponent = (props) => {
    const { isHHMTTheme } = useTheme();
    const { t } = useLang();
    const { showPortalModalName } = usePortalModal();

    const { mpmTimestamp, isMakePaymentAsGuest, paymentStatus } =
      useFxAddTransaction();
    const { redirectToForeignExhangePath, setAddTransactionCurrentStep } =
      useFxFormAddTransactionStore();

    const [isMakePaymentExpired, setMakePaymentExpired] = useState(true);

    const onCheckMakePaymentExpired = () => {
      if (!mpmTimestamp) {
        // A failed/cancelled payment return must stay on the payment screen so
        // the guest can retry Make Payment instead of landing on the receipt.
        const isPaymentRetryable =
          paymentStatus === STATUS_FAIL || paymentStatus === STATUS_CANCELLED;
        if (isMakePaymentAsGuest && !isPaymentRetryable) {
          setAddTransactionCurrentStep(6);
        }
        return;
      }
      const todayTimestamp = new Date(
        datePicker.convertToLocalDateTimeWithTimeZone(
          datePicker.getTodayMilliseconds(),
          'YYYY-MM-DDTHH:mm:ss'
        )
      ).getTime();
      const expiredTimestamp = new Date(
        Number(mpmTimestamp.slice(-13))
      ).getTime();
      if (todayTimestamp > expiredTimestamp) {
        showPortalModalName({
          name: PORTAL_NAME_MODAL_DEFINE.FX_MAKE_PAYMENT_EXPIRED_MODAL,
          content: stringUtils.replaceKeyword(t('popup_make_payment_expired'), [
            { key: 'email', value: FX_EMAIL },
            { key: 'phone', value: FX_PHONE },
          ]),
          action: () => {
            redirectToForeignExhangePath();
          },
        });
      } else {
        setMakePaymentExpired(false);
      }
    };

    useEffect(() => {
      onCheckMakePaymentExpired();
    }, []);

    const newProps = {
      ...props,
      isMakePaymentExpired,
    };
    return <Component {...newProps} />;
  };
  return CheckMakePaymentExpiredComponent;
};

export default withCheckMakePaymentExpired;
